import { render, staticRenderFns } from "./VWID42025Disclosure.vue?vue&type=template&id=c53a467a&"
import script from "./VWID42025Disclosure.vue?vue&type=script&lang=js&"
export * from "./VWID42025Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports